// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world

import wixWindow from 'wix-window';

$w.onReady(function () {
	if (wixWindow.multilingual.currentLanguage === 'en') {
		$w('#faqhe').hide();
		$w('#faqen').show();
	} else {
		$w('#faqen').hide();
		$w('#faqhe').show();
	}
});